import { Grid, CircularProgress, makeStyles, Typography, Paper, Dialog, DialogTitle, DialogContent } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import TableGeneric from '../../../compartidos/abms/TableGeneric';
import ToolbarXLSPDF from '../../../compartidos/ToolbarXLSPDF';
import { useReactToPrint } from 'react-to-print';
import { fetchNomencladorNacional, saveCuenta, savePractica } from '../../../../actions/nomencladoresActions';
import { generateExcelNomenclador, generatePDFNomenclador } from '../../../../actions/contrataciones/contratacionesReportes';
import { FormNomenclador } from './FormNomenclador';
import AddButtonAbm from '../../../compartidos/abms/AddButtonAbm';
import { getPlanes, getPlanesCuentas } from '../../../../actions/contrataciones/contratacionesCartilla';
import BuscadorAbm from '../../../compartidos/abms/BuscadorAbm';
import EditButtonNomenclador from './EditButtonNomenclador';
import { FormCuentaContable } from './FormCuentaContable';
import { useState } from 'react';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(5)
    },
}));

const NomencladorScreen = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const { nomencladorNacional: nomenclador, loading } = useSelector(state => state.nomencladores)
    const [open, setOpen] = useState(false)
    const [practica, setPractica] = useState(false)

    const componentRef = React.useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const handleSavePractica = (data, handleClose) => {
        dispatch(savePractica(data, handleClose, setPractica, setOpen))
    };

    const handleSaveCuentas = (data, handleClose) => {
        dispatch(saveCuenta(data, handleClose, practica))
    };

    useEffect(() => {
        dispatch(getPlanes())
        dispatch(getPlanesCuentas())
    }, [dispatch, nomenclador]);

    return (
        <div className={classes.root}>
            <Grid container justify="center" spacing={2}>
                <Grid item xs={12} md={11} style={{paddingLeft:0}}>
                    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
                        <DialogTitle>Crear cuenta</DialogTitle>
                        <DialogContent>
                            <FormCuentaContable
                                formData={null}
                                handleSubmit={(data) => handleSaveCuentas(data, () => setOpen(false))}
                                handleCancel={() => setOpen(false)}
                                editable={true}
                            />
                        </DialogContent>
                    </Dialog>
                </Grid>
                <Grid item xs={12} md={6}>
                    <BuscadorAbm title="Buscar Practicas por nombre o codigo" handleSearch={(texto) => dispatch(fetchNomencladorNacional(true, texto))} />
                </Grid>
                <Grid item xs={12} md={11} style={{paddingLeft:0}}>
                    <AddButtonAbm
                        title="+ Agregar práctica"
                        handleSave={handleSavePractica}
                        permiso={null}
                        form={FormNomenclador}
                    />
                </Grid>
                <Grid item xs={12} md={11}>
                    <Grid container justify="space-between" alignItems="center" component={Paper} spacing={2}>
                        <Grid item >
                            <Typography variant="subtitle1">
                                Listado de Prácticas Nomenclador
                                {
                                    loading &&
                                    <CircularProgress size={24} style={{ marginLeft: 15 }} />
                                }
                            </Typography>
                        </Grid>
                        <Grid item>
                            <ToolbarXLSPDF
                                handlePrint={handlePrint}
                                handleExportExcel={() => dispatch(generateExcelNomenclador())}
                                handleGeneratePdf={() => dispatch(generatePDFNomenclador())}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TableGeneric
                                ref={componentRef}
                                data={nomenclador}
                                columns={[
                                    {
                                        label: "",
                                        id: "",
                                        customBody: (item) => (
                                            <>
                                                <EditButtonNomenclador
                                                    handleSave={handleSavePractica}
                                                    handleSaveCuentas={handleSaveCuentas}
                                                    permiso={null}
                                                    item={item}
                                                    Form={FormNomenclador}
                                                    SecondForm={FormCuentaContable}
                                                />
                                            </>
                                        )
                                    },
                                    {
                                        label: "Código",
                                        id: "codNom",
                                        sort: true
                                    },
                                    {
                                        label: "Descripción",
                                        id: "desNom",
                                        sort: true,
                                    },
                                    {
                                        label: "Nomenclada",
                                        id: "nomenclada",
                                        sort: true,
                                        customBody: (item) => item.nomenclada === "S" ? "Si" : item.nomenclada === "N" ? "No" : "No especificado"
                                    }
                                ]}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div >
    )
}

export default NomencladorScreen
